import { render, staticRenderFns } from "./DivideComponent.vue?vue&type=template&id=31e76d96&scoped=true&"
import script from "./DivideComponent.vue?vue&type=script&lang=js&"
export * from "./DivideComponent.vue?vue&type=script&lang=js&"
import style0 from "./DivideComponent.vue?vue&type=style&index=0&id=31e76d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e76d96",
  null
  
)

export default component.exports